import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
/**
 * Navigation menu item
 */

import * as React from 'react';
import classnames from 'classnames';
import SvgInline from '@latitude/svg-inline';
import './_menu-item.scss';

var MenuItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleClick = function () {
      return _this.props.onClick(_this.props.id);
    };

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        href = _this$props.href,
        target = _this$props.target,
        icon = _this$props.icon,
        label = _this$props.label,
        bgGrey = _this$props.bgGrey,
        labelBold = _this$props.labelBold,
        labelOnly = _this$props.labelOnly,
        trackId = _this$props.trackId;
    var className = classnames('menu-item', this.props.className, {
      'menu-item--bg-grey': bgGrey
    }, {
      'menu-item--label-bold': labelBold
    }, {
      'menu-item--label-only': labelOnly
    }, {
      'menu-item--indent-left-mobile': this.props.indentLeftMobile
    }, {
      'menu-item--desktop-only': this.props.desktopOnly
    }, {
      'menu-item--mobile-only': this.props.mobileOnly
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("a", {
      href: href,
      className: "menu-item__button link--no-style trackcustomanalytics",
      onClick: this.handleClick,
      "data-trackid": trackId,
      target: target
    }, icon && /*#__PURE__*/React.createElement(SvgInline, {
      className: "menu-item__icon",
      name: icon,
      strokeGreyDark: true
    }), label && /*#__PURE__*/React.createElement("p", {
      className: "menu-item__label"
    }, label), /*#__PURE__*/React.createElement(SvgInline, {
      className: "menu-item__chevron",
      name: "chevron-right"
    })));
  };

  return MenuItem;
}(React.Component);

export default MenuItem;